import { getUserData, getCarousel } from "@/services/api/ShowcaseServiceApi";

const DEFAULT_STATE = {
  titleBreadcrumbs: 'Vitrine',
  loading: false,
  dashboardLoading: false,
  vehiclesCampaignLoading: false,
  vehiclesFilterLoading: false,
  cacheLoaded: false,
  slug: '',
  request: null,
  mobile: false,
  result: [],
  filters: [],
  aliasFilter: {
    'quotation': 'modalidade',
    'vehicleCondition': 'condicao',
    'typeVehicle': 'tipo',
    'reportStatus': 'laudo',
    'optionals': 'opcionais',
    'fuel': 'combustiveis',
    'transmission': 'transmissoes',
  },
  params: {},
  fipe: 0,
  priceMin: undefined,
  priceMax: undefined,
  yearMin: undefined,
  yearMax: undefined,
  kmMin: undefined,
  kmMax: undefined,
  page: 1,
  perPage: 0,
  total: 0,
  totalResults: 0,
  totalOfResult: 0,
  orderBy: "",
  view: "grid",
  optionalsData: {
    optionals: [],
    fuel: [],
    transmission: [],
    brands: [],
    filteredBrands: [],
  },
  userData: {},
  carousel: [],
  resultDashboardVehicleIds: [],
  resultCampaignVehicleIds: [],
};

const filterShowcaseModule = {
  namespaced: true,
  state() {
    return DEFAULT_STATE;
  },
  mutations: {
    setView(state, view) {
      state.view = view;
    },
    setTitleBreadcrumb(state, title) {
      state.titleBreadcrumbs = title;
    },
    setSelectedCarousel(state, selectedCarousel) {
      state.selectedCarousel = selectedCarousel;
    },
    setUserData(state, userData) {
      state.userData = userData;
    },
    setCarousel(state, carousel) {
      state.carousel = carousel;
      state.resultDashboardVehicleIds = []
      state.loading = false;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setDashboardLoading(state, loading) {
      state.dashboardLoading = loading;
    },
    setVehiclesCampaignLoading(state, loading) {
      state.vehiclesCampaignLoading = loading;
      state.vehiclesFilterLoading = loading;
    },
    setSlug(state, slug) {
      state.slug = slug;
    },
  },
  actions: {
    async getUserData ({ commit }) {
      return getUserData()
        .then((response) => {
          commit("setUserData", response);
          return response;
        })
    },
    async getCarousel ({ commit }, key = null) {
      return getCarousel(key)
        .then((response) => {
          commit('setCarousel', response[key])
          return response;
        })
    },
    async getDashboardData({ commit }) {
      commit("setDashboardLoading", true);
      const [userData, carouselData] = await Promise.all([
        getUserData(),
        getCarousel()
      ]);
      commit("setUserData", userData);
      commit("setCarousel", carouselData);
      commit("setDashboardLoading", false);
    },
  },
};

export default filterShowcaseModule;
